export default "/images/221f8d4c7a1f88074499a55cb891195d.avif";